<template>
  <v-app id="app">
    <main-menu v-model="navigationDrawer" v-if="!isLoginMode"></main-menu>

    <v-app-bar
      v-if="!isLoginMode"
      app
      color="primary"
      dark
    >
      <v-app-bar-nav-icon @click="navigationDrawer = !navigationDrawer"></v-app-bar-nav-icon>
      <v-toolbar-title>Союз отделочников</v-toolbar-title>
      <v-spacer></v-spacer>

      <v-btn icon @click="logout">
        <v-icon>mdi-logout-variant</v-icon>
      </v-btn>
      
    </v-app-bar>

    <v-main v-if="isLoginMode">
        <router-view :key="$route.fullPath"></router-view>
    </v-main>
    <v-main v-else>
      <v-container class="grey lighten-5 fill-height align-start pa-0">
        <router-view/>
      </v-container>

      <v-snackbar
        v-model="showSnackbar"
        :timeout="2000"
      >
        {{ messages[messages.length - 1] }}

        <template v-slot:action="{ attrs }">
          <v-btn
            icon
            @click="showSnackbar = false"
            v-bind="attrs"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </template>
      </v-snackbar>

    </v-main>
  </v-app>
</template>

<script>
export default {  
  data() {
    return {
      navigationDrawer: false,
      showSnackbar: false
    }
  },

  created() {
    // Фиксируем utm-метки в localStorage
    var parseQueryString = function() {
      var str = decodeURI(window.location.search);
      var objURL = {};
      str.replace(
        new RegExp( "([^?=&]+)(=([^&]*))?", "g" ),
        function( $0, $1, $2, $3 ){
            objURL[ $1 ] = $3;
        }
      );
      return objURL;
    };
    var params = parseQueryString();
    if (params['utm_source']) {
      console.log(params['utm_term']);
      localStorage.setItem('utm_source', params['utm_source']);
      localStorage.setItem('utm_medium', params['utm_medium']);
      localStorage.setItem('utm_campaign', params['utm_campaign']);
      localStorage.setItem('utm_term', params['utm_term']);
      localStorage.setItem('utm_content', params['utm_content']);
    }
  },

  methods: {
    logout() {
      this.$store.dispatch('users/logout');
      this.$router.push('/login');
    }
  },

  computed: {
    isLoginMode() {
      return this.$route.name == 'Login' || this.$route.name == 'Signup';
    },
    messages() {
      return this.$store.state.globalMessages;
    }
  },
  watch: {
    showSnackbar: function(newVal, oldVal) {
      if (!newVal) {
       this.$store.commit('POP_MESSAGE');
       if (this.messages.length > 0) {
         this.$nextTick(() => { this.showSnackbar = true })
       }
      }
    },
    messages: function(newVal, oldVal) {
      if (newVal.length > 0 && !this.showSnackbar) this.showSnackbar = true;
    }
  },
}
</script>